import type { KidInCustomer } from '@brighterly/lib-core-types/kid/interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useCustomerStore } from '@stores/me/customer'
import { useKidStore } from '@stores/kid'
import { useDisciplineStore } from '@stores/discipline'

import { useKidRoutes } from '@composables/routes/kid-route.hook'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

interface KidsMenuReturn {
  kids: ComputedRef<KidInCustomer[]>
  activeKid: ComputedRef<KidInCustomer | null>
  setRedirect: (kid: KidInCustomer) => void
}

export const useKidsMenu = (): KidsMenuReturn => {
  const customerStore = useCustomerStore()
  const kidStore = useKidStore()
  const disciplineStore = useDisciplineStore()

  const {
    getHomeMath,
    getHomeEla,
    isRouteDisciplineEla,
  } = useKidRoutes()

  const kids = computed(() => customerStore.customer?.kids || [])

  const activeKid = computed(() => {
    return kids.value.find(kid => kid.id === kidStore.activeKidId) || null
  })

  const setTrackEvent = (kidId: number, url: string | null): void => {
    trackEvent(amplitudeConfig.events.clickTab, {
      name: 'tab_kid_switcher',
      kid_id: kidId,
      href: url,
    })
  }

  const setRedirect = async (kid: KidInCustomer): Promise<void> => {
    const subject = disciplineStore.getDisciplineCode ?? (isRouteDisciplineEla.value ? Discipline.ELA : Discipline.Math)
    const url = subject === Discipline.ELA ? getHomeEla(kid.id) : getHomeMath(kid.id)

    setTrackEvent(kid.id, url)
    await navigateTo(url)
  }

  return {
    kids,
    activeKid,
    setRedirect,
  }
}
